import React, { useState, useRef } from "react";
import { Grid, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { addContact } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { errorNotify, successNotify } from "../../util/functions";
import PostDialog from "../components/PostDialog";
import { IcontactState } from "./interface";


interface IAddProps {
  contactState: IcontactState,
  setContactState: (x: IcontactState) => void
}


const Add = (props: IAddProps) => {

  //props
  const { contactState, setContactState } = props


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setContactState({ ...contactState, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={12} xs={12} sm={12}>
          <TextField
            // fullWidth
            style={{ width: "30%" }}
            size="small"
            name="libContact"
            label="libellé contact"
            value={contactState.libContact}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <TextField
            // fullWidth
            style={{ width: "30%" }}
            size="small"
            name="numero"
            label="Numéro"
            value={contactState.numero}
            onChange={handleInputChange}
          />
        </Grid>
      </Grid>

    </Box>

  );
};

const initialState = { libContact: "", numero: "" }

const DialogAdd = () => {


  //redux
  const dispatch = useDispatch();


  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [contactState, setContactState] = useState<IcontactState>(initialState)


  //Fermer la boite de dialog d'ajout de contact
  const onClose = () => {
    setOpen(false)
  }

  //Ouvrir la boite de dialog d'ajout de contact
  const handleOpenDialog = () => {
    setOpen(true)
  }



  //Enregistrer un contact
  const handleSave = async (e: any) => {
    try {
      e.preventDefault()
      setAddLoading(true)
      const apiPayload = {
        libContact: contactState.libContact,
        numero: contactState.numero
      }
      const res: any = await apiClient.post(SITEWEB_SERVER_BASE_URL, "/ajoutercontact", apiPayload);
      if (res.status === 1) {
        dispatch(addContact(res.data))
        successNotify("Action effectuée avec succès");
        setAddLoading(false)
        setContactState(initialState)
      } else {
        errorNotify("Erreur");
        setAddLoading(false)
      }
    } catch (error) {
      console.log("🚀 ~ file: Add.tsx:106 ~ handleSave ~ error:", error)
    }
  }


  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={
        <Add
          contactState={contactState}
          setContactState={setContactState}
        />}
      actionFunc={handleSave}
      title="Contact"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



